module.exports = __webpack_public_path__ + "static/amare_img_5_h-99ad52eaf2c4a81cef954c78a007a8fb.jpg";